import React, {useState, useEffect} from 'react';
import {Container, Grid, Typography, ButtonBase, ListItem, ListItemIcon, ListItemText, Chip} from '@material-ui/core/';
import {CheckCircleOutline, NavigateNext, Email, Filter1,} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Form from 'components/Form/FormTwoColumns';
import MensajeAlerta from 'components/ResponseElement'
import { useHistory } from "react-router-dom";
import DatosCiudadanoComplemento from './DatosCiudadanoCompleto'
import DatosCiudadanoTSE from './datosDelCiudadano'
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple, showMessageErrorSimple, showMessageError} from 'services/SweetAlert'

function DatosDelCiudadanoResumen(props) {
    let history = useHistory();
    const classes = useStyles(),
        [loading, setLoading] = React.useState(false),
        [elements,setElements] = useState({
            password: {  idelement: "password",  value:"", label: "Ingrese contraseña", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", validators: ['required'], errorMessages:['Ingrese una contraseña válida'], isError:false, elementType:'password', finalRequiredLength: 50, },
        }),
        [apiErrors,setApiErrors] = useState([]),
        [datosCompletos, setDatosCompletos] = useState({}),
        [open, setOpen] = useState(false),
        [disabled, setDisabled] = useState(false),
        [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''});

        const obtenerDatosCompletos = () => {
            let data = Object.assign({}, props.datosCiudadanoTable);
            data.direccion = props.data.direccion;
            data.nocasalote = props.data.nocasalote;
            data.zona = props.data.zona;
            data.departamento = props.data.departamento;
            data.municipio = props.data.municipio;
            data.comunidad = props.data.comunidad;
            data.profesion = props.data.profesion;
            setDatosCompletos(data)
        }
        const backStep=()=>{ props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step-1);   };
        const Cancelar = () => {
            props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
            props.data.direccion = ""
            props.data.nocasalote = ""
            props.data.zona = ""
            props.data.departamento = ""
            props.data.municipio = ""
            props.data.comunidad = ""            
            props.data.profesion = ""            
            props.SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO({ArrayDepartamento:[], ArrayMunicipio:[], ArrayComunidad:[], ArrayOcupaciones:[]})
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA({nombreDepartamento: '', nombreMunicipio: '', nombreComunidad:'', cenVotacion: '',  nombreOcupaciones:'', position1:"",position2:"",position3:"",position4:""})            
            props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step-1);
            props.cerrarDialogo()
        }
        const CancelaryBorrar = () => {
            props.data.direccion = ""
            props.data.nocasalote = ""
            props.data.zona = ""
            props.data.departamento = ""
            props.data.municipio = ""
            props.data.comunidad = ""            
            props.data.profesion = ""       
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA({nombreDepartamento: '', nombreMunicipio: '', nombreComunidad:'', cenVotacion: '',  nombreOcupaciones:'', position1:"",position2:"",position3:"",position4:""})            
            props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step-1);
            props.cerrarDialogo()
        }
        const EmpadronarCiudadano= async()=>{
            setDisabled(true)
            setLoading(true)
            var datos = {
                idSolicitud: props.datosCiudadanoTable.datosSolicitudEmpadronamiento.idSolicitud,
                direccion:  props.data.direccion,
                numeroCasa: props.data.nocasalote,
                numeroZona: props.data.zona,
                departamento: props.data.departamento,
                // nombreDepartamento: props.datosResidencia.nombreDepartamento ,
                municipio: props.data.municipio,
                // nombreMunicipio: props.datosResidencia.nombreMunicipio ,
                comunidad: props.data.comunidad,
                // nombreComunidad: props.datosResidencia.nombreComunidad,
                profesion: props.data.profesion,
                // nombreProfesion: props.datosResidencia.nombreOcupaciones,
                cenVotacion: props.datosResidencia.cenVotacion,
                // password: 'Claridad0204#',
                password: elements.password.value,
            }
            try{
                const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.autorizar(datos);
                if(response.error!==null){
                    setLoading(false)
                    setDisabled(false)
                    // showMessageErrorSimple('¡Oops!', response.error.message)
                    setMensaje({tipoError:'error', tipoMensaje:'Oops!. '+response.error.message})
                    setOpen(true)                      
                }else{
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(true)
                    setLoading(false)
                    setDisabled(false)
                    showMessageSuccessSimple('¡BIEN!','Usuario empadronado correctamente. Solicitud # '+props.datosCiudadanoTable.datosSolicitudEmpadronamiento.idSolicitud)
                    CancelaryBorrar()
                    // props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
                }   
            }catch(exception){
                if (exception.status===404) {
                    setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                    setOpen(true)                      
                }
                else {
                    setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                    setOpen(true)                                          
                }
                setLoading(false)
                setDisabled(false)                
            }               
        };
        const handClose = (event, reason) =>{
            if (reason === 'clickaway') {return ;}
            setOpen(false)
        }
        const [buttonList,setButtonList]= React.useState({
            "next":{"label":"Empadronar ciudadano","icon": <CheckCircleOutline />,"callback":EmpadronarCiudadano,"loading":false,"size":"medium","color":"#fff", "background":"linear-gradient(130deg, rgb(6, 107, 189) 30%, rgb(30, 136, 229) 90%) repeat scroll 0% 0% ",},   
        });     

        useEffect(() => {
            obtenerDatosCompletos()
        },[])
       
    return (
        <div className={classes.root}>
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body1" color="textPrimary"> <strong>RESUMEN</strong></Typography>
                    </Grid>
                    <Grid className={classes.marginText} item xs={12} > 
                        {/* <DatosCiudadano /> */}
                        <DatosCiudadanoTSE {...props} />
                        <DatosCiudadanoComplemento datos={datosCompletos}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>            

            <Container maxWidth="md" className={classes.colorComponente}>
                <Grid container direction="row" justify="center" alignItems="center" >
                    <Grid className={classes.AlignTable} item xs={12} > 
                        <ButtonBase className={classes.image}>
                            <img className={classes.img} alt="complex" src={"/assets/cambiarContraseña.png"} />
                        </ButtonBase>      
                        <h4 className={classes.h1} variant="h5" color="initial"><strong>Ingrese su contraseña de Firma Electrónica para firmar documento.</strong></h4>                 
                        <Form   elements= {elements}  buttonList={buttonList} apiErrors={apiErrors}  BotonRegresar={backStep} BotonCerrar={Cancelar} loading={loading} disabled={disabled}/>
                    </Grid>
                </Grid><br/>
                <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={2000} open={open} handClose={handClose} />
                <div className={classes.lineaDegradadaBottom}></div>
            </Container><br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosDelCiudadanoResumen);